<template>
  <BasePanelWithHeader>
    <template v-slot:header>
      <span
        >User Agencies
        <BaseTooltipButton
          @click="$refs.userAgencyForm.addUserAgency()"
          icon="mdi-plus"
          class="float-right"
          iconColor="secondary"
          buttonClass="white"
          x-small
          >Add User Agency
        </BaseTooltipButton>
      </span>
    </template>
    <template v-slot:content>
      <v-data-table
        :headers="filteredHeaders"
        :items="selectedUserAgencies"
        :search="searchText"
        class="pt-4"
        dense
      >
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.userAgencyForm.editUserAgency(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit User Agency
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            v-if="item.ID > 0"
            small
            @click="$refs.userAgencyDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete User Agency
          </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="userAgencyDelete"
        :delete="deleteUserAgency"
        @refresh="$emit('refreshUserAgencies')"
      >
        Are you sure you want to delete this user agency?
      </BaseDeleteConfirm>
      <UserAgencyDialogForm
        :selectedUserID="selectedUserID"
        :selectedAgencyID="selectedAgencyID"
        ref="userAgencyForm"
        @refresh="$emit('refreshUserAgencies')"
        @newUserAgency="addUserAgency"
      >
      </UserAgencyDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import { authMethods, authComputed } from '@state/helpers'
import { get, sync, commit, call } from 'vuex-pathify'
import UserAgencyDialogForm from '@components/form/add-edit/UserAgencyDialog'
export default {
  components: {
    UserAgencyDialogForm,
  },
  data: () => ({
    searchText: '',
  }),
  props: {
    selectedUserAgencies: {
      type: Array,
    },
    selectedUserID: {
      type: Number,
      required: true,
    },
    selectedAgencyID: {
      type: Number,
    },
  },
  created() {},
  computed: {
    ...authComputed,
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'User ID',
          align: 'center',
          sortable: true,
          value: 'UserID',
          visible: false,
        },
        {
          text: 'Agency',
          align: 'center',
          sortable: true,
          value: 'Agency.Name',
          visible: this.isSuperUser,
        },
        {
          text: 'Agency Role',
          align: 'center',
          sortable: true,
          value: 'AgencyRole.Description',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: true,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('userAgency', ['deleteUserAgency']),
    addUserAgency(ua) {
      this.$emit('newUserAgency', ua)
    },
  },
}
</script>
<style>
</style>